import { Component } from '@angular/core';

declare var jQuery: any;

@Component({
  standalone: false,
    selector: 'app-blank',
    templateUrl: 'blankLayout.template.html',
})
export class BlankLayoutComponent {
}
